import { CalendarioVacinasViewComponent } from "./calendario-vacinas-view/calendario-vacinas-view.component";
import { HttpClient } from "@angular/common/http";
import { IdiomasComponent } from "./idiomas/idiomas.component";
import { SkeletonComponent } from "./skeleton-component/skeleton-component";
import { EmptyListComponent } from "./empty-list-component/empty-list-component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ItemHeaderComponent } from "./item-header-component/item-header-component";
import { CardInfoPacienteComponent } from "./card-info-paciente-component/card-info-paciente-component";
import { CardDadosAutodeclaratorioComponent } from "./card-dados-autodeclaratorio-component/card-dados-autodeclaratorio-component";
import { TimeLineComponent } from "./time-line-component/time-line-component";
import { SummaryComponent } from "./summary-component/summary-component";
import { HistoryFilterComponent } from "./history-filter-component/history-filter-component";
import { ItemPopoverComponent } from "./item-popover-component/item-popover-component";
import { ListItensComponent } from "./list-itens-component/list-itens-component";
import { CalendarioVacinasComponent } from "./calendario-vacinas-component/calendario-vacinas-component";
import { DetalheVacinaComponent } from "./detalhe-vacina-component/detalhe-vacina-component";
import { PipesModule } from "src/app/pipe/pipes.module";
import { TimeLineAlergiaComponent } from "./time-line-alergia-component/time-line-alergia-component";
import { TimeLineMedicamentoComponent } from "./time-line-medicamento-component/time-line-medicamento-component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "../../util/translateLoader";
import { PrescricoesComponent } from "./prescricoes-component/prescricoes-component";
import { PrescricoesListComponent } from "./prescricoes-list-component/prescricoes-list-component";
import { PrescricoesDetalheComponent } from "./prescricoes-detalhe-component/prescricoes-detalhe-component";
import { PrescricoesMedComponent } from "./prescricoes-med-component/prescricoes-med-component";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { DiarioSaudeComponent } from "./diario-saude-component/diario-saude-component";
import { MedicamentosComponent } from "./medicamentos-component/medicamentos-component";
import { MedicamentoDetalheComponent } from "./medicamento-detalhe-component/medicamento-detalhe-component";
import { AtendimentoInternacaoComponent } from "./atendimento-internacao-component/atendimento-internacao-component";
import { AtendimentosListComponent } from "./atendimentos-list-component/atendimentos-list-component";
import { ExamesComponent } from "./exames-component/exames-component";
import { ExamesListComponent } from "./exames-list-component/exames-list-component";
import { AtendimentoDetalheComponent } from "./atendimento-detalhe-component/atendimento-detalhe-component";
import { ContatosComponent } from "./contatos-component/contatos-component";
import { BoasVindasComponent } from "./boas-vindas-component/boas-vindas-component";
import { ExameDetalheComponent } from "./exame-detalhe-component/exame-detalhe-component";
import { BrMaskerModule } from "br-mask";
import { InternacoesListComponent } from "./internacoes-list-component/internacoes-list-component";
import { AutocompleteSelectorComponent } from "./autocomplete-selector/autocomplete-selector.component";

import { TodosDocumentosComponent } from "./todos-documentos/todos-documentos.component";
import { BoxFilterComponentComponent } from "./box-filter-component/box-filter-component.component";
import { CardListComponentComponent } from "./card-list-component/card-list-component.component";
import { CardVacinaComponentComponent } from "./card-vacina-component/card-vacina-component.component";
import { CardSolicitacaoReguladaComponentComponent } from "./card-solicitacao-regulada-component/card-solicitacao-regulada-component.component";
import { CardAtendimentoClinicoComponentComponent } from "./card-atendimento-clinico-component/card-atendimento-clinico-component.component";
import { SolicitacoesReguladasListComponent } from "./solicitacoes-reguladas-list/solicitacoes-reguladas-list.component";
import { CardExamesComponentComponent } from "./card-exames-component/card-exames-component.component";
import { CardMedicamentosComponentComponent } from "./card-medicamentos-component/card-medicamentos-component.component";
import { CardInternacoesComponentComponent } from "./card-internacoes-component/card-internacoes-component.component";
import { CardAlergiasComponentComponent } from "./card-alergias-component/card-alergias-component.component";
import { CardPressaoComponentComponent } from "./card-pressao-component/card-pressao-component.component";
import { PressaoComponentComponent } from "./pressao-component/pressao-component.component";
import { GlicoseComponentComponent } from "./glicose-component/glicose-component.component";
import { CardGlicoseComponentComponent } from "./card-glicose-component/card-glicose-component.component";
import { SuporteComponentComponent } from "./suporte-component/suporte-component.component";
import { ImcComponentComponent } from "./imc-component/imc-component.component";
import { MedicamentosDeclaradosComponentComponent } from "./medicamentos-declarados-component/medicamentos-declarados-component.component";
import { CardMedicamentosDeclaradosComponentComponent } from "./card-medicamentos-declarados-component/card-medicamentos-declarados-component.component";
import { CardImcComponentComponent } from "./card-imc-component/card-imc-component.component";
import { RegistrosAutodeclaradosComponentComponent } from "./registros-autodeclarados-component/registros-autodeclarados-component.component";
import { AtestadosListComponentComponent } from './atestados-list-component/atestados-list-component.component';
import { CardAtestadosComponentComponent } from "./card-atestados-component/card-atestados-component.component";
import { CardPrescricoesComponentComponent } from "./card-prescricoes-component/card-prescricoes-component.component";
import { DateFilterComponent } from "./date-filter/date-filter.component";

@NgModule({
  imports: [
    IonicModule.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    BrMaskerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    DateFilterComponent,
    ItemHeaderComponent,
    CardInfoPacienteComponent,
    CardDadosAutodeclaratorioComponent,
    TimeLineAlergiaComponent,
    TimeLineMedicamentoComponent,
    TimeLineComponent,
    EmptyListComponent,
    SkeletonComponent,
    SummaryComponent,
    HistoryFilterComponent,
    ItemPopoverComponent,
    ListItensComponent,
    CalendarioVacinasComponent,
    CalendarioVacinasViewComponent,
    DetalheVacinaComponent,
    PrescricoesComponent,
    PrescricoesListComponent,
    PrescricoesDetalheComponent,
    PrescricoesMedComponent,
    EmptyStateComponent,
    DiarioSaudeComponent,
    MedicamentosComponent,
    MedicamentoDetalheComponent,
    AtendimentoInternacaoComponent,
    AtendimentosListComponent,
    AtendimentoDetalheComponent,
    ExamesComponent,
    ExamesListComponent,
    ExameDetalheComponent,
    ContatosComponent,
    BoasVindasComponent,
    IdiomasComponent,
    AutocompleteSelectorComponent,
    InternacoesListComponent,
    SolicitacoesReguladasListComponent,
    TodosDocumentosComponent,
    BoxFilterComponentComponent,
    PressaoComponentComponent,
    GlicoseComponentComponent,
    ImcComponentComponent,
    SuporteComponentComponent,
    MedicamentosDeclaradosComponentComponent,
    RegistrosAutodeclaradosComponentComponent,
    AtestadosListComponentComponent,
    CardListComponentComponent,
    CardVacinaComponentComponent,
    CardSolicitacaoReguladaComponentComponent,
    CardAtendimentoClinicoComponentComponent,
    CardExamesComponentComponent,
    CardMedicamentosComponentComponent,
    CardAlergiasComponentComponent,
    CardInternacoesComponentComponent,
    CardPressaoComponentComponent,
    CardGlicoseComponentComponent,
    CardMedicamentosDeclaradosComponentComponent,
    CardImcComponentComponent,
    CardAtestadosComponentComponent,
    CardPrescricoesComponentComponent,
  ],
  exports: [
    DateFilterComponent,
    ItemHeaderComponent,
    CardInfoPacienteComponent,
    CardDadosAutodeclaratorioComponent,
    TimeLineAlergiaComponent,
    TimeLineMedicamentoComponent,
    TimeLineComponent,
    EmptyListComponent,
    SkeletonComponent,
    SummaryComponent,
    HistoryFilterComponent,
    ItemPopoverComponent,
    ListItensComponent,
    CalendarioVacinasComponent,
    CalendarioVacinasViewComponent,
    DetalheVacinaComponent,
    PrescricoesComponent,
    PrescricoesListComponent,
    PrescricoesDetalheComponent,
    PrescricoesMedComponent,
    EmptyStateComponent,
    DiarioSaudeComponent,
    MedicamentosComponent,
    MedicamentoDetalheComponent,
    AtendimentoInternacaoComponent,
    AtendimentosListComponent,
    AtendimentoDetalheComponent,
    ExamesComponent,
    ExamesListComponent,
    ExameDetalheComponent,
    ContatosComponent,
    BoasVindasComponent,
    IdiomasComponent,
    AutocompleteSelectorComponent,
    InternacoesListComponent,
    SolicitacoesReguladasListComponent,
    TodosDocumentosComponent,
    BoxFilterComponentComponent,
    PressaoComponentComponent,
    GlicoseComponentComponent,
    ImcComponentComponent,
    SuporteComponentComponent,
    MedicamentosDeclaradosComponentComponent,
    RegistrosAutodeclaradosComponentComponent,
    AtestadosListComponentComponent,
    CardListComponentComponent,
    CardVacinaComponentComponent,
    CardSolicitacaoReguladaComponentComponent,
    CardAtendimentoClinicoComponentComponent,
    CardExamesComponentComponent,
    CardMedicamentosComponentComponent,
    CardAlergiasComponentComponent,
    CardInternacoesComponentComponent,
    CardPressaoComponentComponent,
    CardGlicoseComponentComponent,
    CardMedicamentosDeclaradosComponentComponent,
    CardImcComponentComponent,
    CardAtestadosComponentComponent,
    CardPrescricoesComponentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule { }
